"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var e=function(r,o){try{arguments.length===1?console.error(r):console.error(r,o)}catch{}};exports.hostReportErrors=e;
